module.exports = __webpack_public_path__ + "static/media/img_9.413c749c.JPG";